export default __webpack_public_path__ + "static/media/revenue_ko@2x.b82c5fcb.png";